import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ColorationGasBlock } from '@core/models/coloration-context.model';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ColorationGasBlockService {
  private http = inject(HttpClient);

  private baseUrl: string = environment.apiUrl + '/colorationgasblock';

  public getColorationGasBlock(): Observable<Array<ColorationGasBlock>> {
    return this.http.get<Array<ColorationGasBlock>>(this.baseUrl);
  }

  public removeColorationGasBlock(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  public upsertColorationGasBlock(colorationGasBlock: ColorationGasBlock): Observable<ColorationGasBlock> {
    return this.http.post<ColorationGasBlock>(this.baseUrl, colorationGasBlock);
  }

  public setDefaultColorationGasBlock(id: string): Observable<boolean> {
    return this.http.post<boolean>(`${this.baseUrl}/default`, { id });
  }
}
